/**
 * A credit count in the reader's locale ("1,590" in English, "1.590" in
 * Spanish). Anything that isn't a finite number (the store's "—" while loading,
 * "unavailable") passes through unchanged.
 *
 * Callers pass the app's i18n locale, never the browser default, so the server
 * and the client print the same thing.
 */
export function formatCreditCount(
  value: number | string | null | undefined,
  locale: string
): string {
  if (typeof value === 'number' && Number.isFinite(value)) {
    // Group every 4+ digit count, Spanish included ("1.590"): CLDR's default
    // leaves 4-digit Spanish numbers ungrouped ("1590"), which reads as the bug.
    return new Intl.NumberFormat(locale, {
      useGrouping: 'always'
    } as Intl.NumberFormatOptions).format(value);
  }
  return value == null ? '' : String(value);
}
